export const blockIconsPrivacyandsecurityShieldLockedNew = (
	<span className='material-symbols-outlined'>shield_locked</span>
);
